import { MetadatiRepertorioVO } from "./metadati-repertorioVO";

export class NotaDaSostituireVO {
  id: string;
  oggetto: string;
  dataApprovazione: string;
  metadatiRepertorio: MetadatiRepertorioVO;
}
